module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outright03.77de85c8.svg";